<script setup lang="ts">
import {type Ref, ref} from 'vue'
import {type MenuResponse} from "../../responses/MenuResponse";
import {type MenuItemResponse} from "../../responses/MenuItemResponse";
import {ChevronRightIcon, ChevronLeftIcon} from "lucide-vue-next";
interface Props {
    menu: MenuResponse
}

const props = defineProps<Props>()

const isOpen = ref(false)
const history: Ref<MenuItemResponse[]> = ref([])
const activeItem: Ref<MenuItemResponse|null> = ref(null);

function toggleMenu() {
    isOpen.value = !isOpen.value
    if (!isOpen.value) history.value = []
}

function closeMenu() {
    isOpen.value = false
    history.value = []
}

function goToSubmenu(item) {
    activeItem.value = item;
    history.value.push(item.items)
}

function goBack() {
    history.value.pop();
    if(activeItem.value?.parent) activeItem.value = activeItem.value.parent;
    if(history.value.length === 0) activeItem.value = null;
}
</script>
<template>
    <div>
        <a href="#" @click="toggleMenu" class="relative flex rounded-lg h-9 w-9 lg:h-12 lg:w-12 justify-center items-center border border-gray-200">
            <svg class="h-6 w-6 lg:h-7 lg:w-7" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
        </a>
        <transition name="fade">
            <div v-if="isOpen" class="fixed inset-0 bg-black/40 w-full z-10 lg:hidden top-16" @click.self="closeMenu"></div>
        </transition>
        <transition name="slide-left">
            <div v-if="isOpen" class="fixed top-16 left-0 bottom-0 w-80 bg-white z-50 overflow-hidden shadow-xl flex flex-col">
                <div class="relative w-full h-full">
                    <div class="absolute inset-0 transition-transform duration-300 ease-in-out">
                        <div v-for="(parentItem, index) in [props.menu.items, ...history]" :key="index" class="absolute top-0 left-0 w-full h-full overflow-y-auto bg-white">
                            <div class="px-4 py-2 border-b border-gray-200 bg-gray-100 flex items-center justify-between" v-if="history.length">
                                <button v-if="index > 0" @click="goBack" class="text-sm text-gray-800 font-bold flex gap-1 justify-center">
                                    <ChevronLeftIcon class="h-4 w-4"></ChevronLeftIcon>
                                    Terug
                                </button>
                            </div>
                            <div class="px-4 py-2 border-b border-gray-200 bg-gray-100 flex items-center justify-between" v-if="activeItem !== null">
                                <a :href="activeItem.slug" class="text-sm font-medium text-gray-800">
                                    {{ activeItem.label }}
                                </a>
                            </div>
                            <ul>
                                <li v-for="item in parentItem" :key="item.label" class="border-b border-gray-200">
                                    <div class="flex items-center justify-between px-4 py-2 w-full">
                                        <a v-if="!item.hasOwnProperty('items') || item.items?.length === 0" :href="item.slug" class="text-sm font-medium text-gray-800">
                                            {{ item.label }}
                                        </a>
                                        <a v-else href="javascript:" @click="goToSubmenu(item)" class="text-sm font-medium text-gray-800 w-full flex">
                                            <span class="w-full">{{ item.label }}</span>
                                            <ChevronRightIcon class="h-4 w-4 justify-end items-end"></ChevronRightIcon>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
